import styled from "styled-components";

export const OpenAppWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  opacity: 0.3;
  background: #000;
  z-index: 1000;
`;

export const OpenAppContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10000;
  transform: translate(-50%, -50%);
  padding: 54px 15px 24px 15px;
  background-color: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  > .title {
    color: var(--Black-500, #202020);
    text-align: center;

    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 22.4px */
  }

  > .button-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    > .button {
      border-radius: 8px;
      width: 135px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    > .button.cancel {
      width: 145px;
      color: var(--Purple-300, #6436e7);
      text-align: center;

      font-size: 13px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
    }

    > .button.open {
      background: var(--Purple-300, #6436e7);
      color: #fff;
      text-align: center;

      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
    }
  }
`;
